// ProjectDetail.js
import React, { useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import projects from "../Constant/ProjectData";
import { Helmet } from "react-helmet-async";
import { Fade } from "react-awesome-reveal";
import NotFoundPage from "./NotFoundPage";
import FAQSection from "../sections/FAQSection";
import FAQSchemaGenerator from "../modules/FAQSchemaGenerator";

const ProjectDetail = () => {
	const { slug } = useParams();

	// Find the project that matches the slug
	const project = projects.find((proj) => proj.slug === slug);
	const origin = window.location.origin;

	useEffect(() => {
		window.scrollTo(0, 0);
	}, [project]);

	if (!project) {
		return <NotFoundPage />;
	}
	return (
		<div className="wrapper project-single">
			<Helmet>
				<title>{project.seo.title}</title>
				<meta name="description" content={project.seo.metaDescription} />
				<meta name="keywords" content={project.seo.keywords.join(", ")} />
				<meta name="author" content="Murtaza Lightwala" />
				<meta name="robots" content="index, follow" />
				<meta charset="UTF-8" />

				{/* Twitter */}
				<meta name="twitter:card" content="summary_large_image" />
				<meta name="twitter:title" content={project.seo.title} />
				<meta
					name="twitter:description"
					content={project.seo.metaDescription}
				/>
				<meta name="twitter:image" content={`${origin}/${project.image.src}`} />
				<meta name="twitter:site" content="@rationalmurtaza" />
				{/* Twitter */}

				{/* Facebook */}
				<meta property="og:title" content={project.seo.title} />
				<meta property="og:description" content={project.seo.metaDescription} />
				<meta property="og:image" content={`${origin}/${project.image.src}`} />
				<meta property="og:url" content={`${origin}/projects/${slug}`} />
				<meta property="og:type" content="website" />
				{/* Facebook */}
				<link rel="canonical" href={`${origin}/projects/${slug}`} />
				<script type="application/ld+json">
				{JSON.stringify(FAQSchemaGenerator({ slug: slug }))}
			</script>
			</Helmet>
			{/* Section Started Heading */}
			<header className="section section-inner started-heading">
				<div className="container">
					<div className="row">
						<div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
							{/* titles */}
							<Fade direction="up" triggerOnce>
								<div className="h-titles">
									<h1 className="h-title" data-animate="active">
										{project.title}
									</h1>
								</div>
							</Fade>
						</div>
					</div>
				</div>
			</header>

			{/* Details */}
			<section className="section section-inner details">
				<div className="container">
					<div className="row row-custom">
						<div className="col-xs-12 col-sm-12 col-md-3 col-lg-3"></div>
						<aside className="col-xs-12 col-sm-12 col-md-9 col-lg-9 vertical-line">
							<div className="m-details">
								<Fade direction="up" cascade={true} damping={0.5} triggerOnce>
									<div className="details-label">
										<span>Year</span>
										<strong>{project.year}</strong>
									</div>
									<div className="details-label">
										<span>Technology</span>
										<strong>{project.technologies.join(", ")}</strong>
									</div>
								</Fade>
							</div>
						</aside>
					</div>
				</div>
			</section>

			{/* Description */}
			<section style={{ padding: "2em 0" }} className="section section-bg">
				<div className="container">
					<div className="row">
						<article className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
							<Fade direction="up" triggerOnce>
								<div className="p-title" data-animate="active">
									About
								</div>
							</Fade>
							<div className="text" data-animate="active">
								{/* Project description content */}
								<Fade direction="up" cascade={true} damping={0.5} triggerOnce>
									<div
										style={{ textAlign: "justify" }}
										dangerouslySetInnerHTML={{
											__html: project.description,
										}}
									/>
								</Fade>
							</div>
						</article>
					</div>
				</div>
			</section>

			{/* Navigation */}
			<nav className="m-page-navigation">
				<div className="container">
					<div className="row">
						<div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
							{/* Navigation to the next project */}
							{project.nextProject && (
								<div className="h-titles h-navs">
									<Link to={`/projects/${project.nextProject.slug}`}>
										<Fade
											direction="up"
											cascade={true}
											damping={0.5}
											triggerOnce
										>
											<span className="nav-arrow">Next Project</span>
											<span className="h-title">
												{project.nextProject.name}
											</span>
										</Fade>
									</Link>
								</div>
							)}
						</div>
					</div>
				</div>
			</nav>
			<FAQSection slug={slug} sectionBg={true} />
		</div>
	);
};

export default ProjectDetail;
